import React, { useState, useEffect, useMemo } from "react";
import {
  ordersCollection,
  useData,
} from "../../../components/firebase/DataProvider";
import { useHistory } from "react-router-dom";
import { date } from "../../../utils/dateTime";
import TabPanel from "../../../components/TabPanel";
import useStyle from "./style";
import Gap from "../../../components/Gap";
import currency from "../../../utils/currency";
//material
import LoopIcon from "@material-ui/icons/Loop";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
// import RedeemIcon from "@material-ui/icons/Redeem";
import Brightness1Icon from "@material-ui/icons/Brightness1";
// import Circle from "../../../components/appLoading/circle";
import EmptyOrder from "./EmptyOrder";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSnackbar } from "notistack";
import { Button, Grid } from "@material-ui/core";

const SubOrderItem = ({ suborder }) => {
  const classes = useStyle();
  const history = useHistory();
  const [seeProduk, setSeeProduk] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const alamat = useMemo(() => {
    let penerima = "";
    let line1 = "";
    let line2 = [];
    let line3 = [];

    const {
      alamat_tujuan: {
        nama_penerima,
        no_telepon,
        alamat_lengkap,
        kelurahan,
        kecamatan,
        kota,
        provinsi,
      },
    } = suborder;
    penerima += `${nama_penerima} (${no_telepon})`;
    line1 += alamat_lengkap ? alamat_lengkap : "";
    line2.push(kelurahan?.name);
    line2.push(kecamatan?.name);
    line3.push(kota?.name);
    line3.push(provinsi?.name);
    line3.push(kelurahan?.postcode);

    line2 = line2.join(", ");
    line3 = line3.join(", ");

    return (
      <div>
        <Typography className={classes.liquidBold}>{penerima}</Typography>
        <Typography className={classes.liquidBold}>{line1}</Typography>
        <Typography className={classes.liquidBold}>{line2}</Typography>
        <Typography className={classes.liquidBold}>{line3}</Typography>
      </div>
    );
  }, [suborder]);

  const products = useMemo(() => {
    const {
      products_name,
      products_variant1,
      products_variant2,
      products_qty,
    } = suborder;
    return (
      <Typography
        className={classes.liquidBold}
      >{`${products_name?.[0]} - ${products_variant1?.[0]} ${products_variant2?.[0]} - ${products_qty?.[0]} pcs `}</Typography>
    );
  }, [suborder]);

  const sumQty =
    suborder?.products_qty?.reduce?.((total, val) => {
      if (!val) return total;
      return total + val;
    }, 0) ?? 0;

  return (
    <>
      <Paper elevation={0} className={classes.wrapPaper}>
        {/* <div className={classes.wrapHeaderTitle}>
          <div>
            <Typography className={classes.liquidBold}>
              #{suborder.kode_order}
            </Typography>
            <Typography className={classes.liquidBold}>
              #{suborder.kode_suborder}
            </Typography>
            <Typography className={classes.liquidSecondList}>
              {date(suborder.created_at?.toDate?.())}
            </Typography>
          </div>
          <div className={classes.belumBayar}>
            <Brightness1Icon style={{ fontSize: "10px" }} color="primary" />
            <Typography className={classes.liquidSecondList}>
              Diprosess
            </Typography>
          </div>
        </div> */}
        <div className={classes.wrapHeaderTitle}>
          <div>
            <Typography className={classes.liquidSecondList}>
              {date(suborder.created_at?.toDate?.())}
            </Typography>
          </div>
          <div className={classes.belumBayar}>
            <Brightness1Icon
              color="primary"
              style={{ fontSize: "10px", marginRight: "5" }}
            />
            <Typography className={classes.liquidSecondList}>
              Diprosess
            </Typography>
          </div>
        </div>
        <Divider />
        <div
          className={classes.wrapHeaderTitle}
          style={{ marginBottom: "10px", marginTop: "10px" }}
        >
          <div>
            <CopyToClipboard
              text={suborder.kode_order}
              onCopy={() => {
                enqueueSnackbar("Kode Order Berhasil Disalin", {
                  variant: "success",
                });
              }}
            >
              <Typography variant="caption" display="block">
                <b>{suborder.kode_order}</b>
              </Typography>
            </CopyToClipboard>{" "}
            <Typography variant="caption" display="block">
              <b>{suborder.kode_suborder}</b>
            </Typography>
          </div>
          <div className={classes.belumBayar}>
            <FileCopyOutlinedIcon
              color="primary"
              style={{ width: "15", height: "15" }}
            />
          </div>
        </div>
        {/* <Grid container direction="row" justify="center" alignItems="center">
          <div className={classes.orderColTopLeft}>
            <div className={classes.innerRow}>
              <div className={classes.timelineStatus}>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      suborder.status === "pending" ||
                      suborder.status === "paid" ||
                      suborder.status === "on-process" ||
                      suborder.status === "on-delivery" ||
                      suborder.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <ScheduleIcon />
                  </div>
                </div>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      suborder.status === "paid" ||
                      suborder.status === "on-process" ||
                      suborder.status === "on-delivery" ||
                      suborder.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <CheckCircleIcon />
                  </div>
                </div>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      suborder.status === "on-process" ||
                      suborder.status === "on-delivery" ||
                      suborder.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <AutorenewIcon />
                  </div>
                </div>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      suborder.status === "on-delivery" ||
                      suborder.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <LocalShippingIcon />
                  </div>
                </div>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      suborder.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <RoomIcon />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid> */}
        <List>
          {/* <ListItem>
            <ListItemText
              primary={
                <Typography className={classes.liquidPrimary}>
                  {sumQty} pcs / {suborder?.products?.length} produk
                </Typography>
              }
            />
            <ListItemSecondaryAction>
              <Typography className={classes.liquidBold}>
                Total Pembayaran{" "}
              </Typography>
              <Typography className={classes.liquidBold}>
                {currency(suborder.total_pembayaran)}
              </Typography>
            </ListItemSecondaryAction>
          </ListItem> */}
          {suborder?.resi_otomatis_mp ? (
            <ListItem
              style={{ backgroundColor: "#C9D6FC" }}
              className={classes.accordion}
            >
              <Grid container>
                <Grid item xs>
                  <Typography variant="caption" display="block">
                    Kode Resi Marketplace :
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="caption" display="block">
                    {suborder?.resi_otomatis_mp_resi}
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
          ) : null}
          <ListItem style={{ backgroundColor: "#C7D9FF" }}>
            <ListItemText
              primary={
                <Typography className={classes.liquidPrimary}>
                  Dikirim ke
                </Typography>
              }
              secondary={alamat}
            />
          </ListItem>
          {seeProduk !== 0 ? (
            <>
              {suborder.products?.map?.((product, index) => {
                return (
                  <ListItem button onClick={() => setSeeProduk(0)}>
                    <ListItemAvatar>
                      <Avatar
                        variant="square"
                        src={
                          suborder.products?.[index]?.variant?.thumbnail?.[0]
                        }
                      />
                    </ListItemAvatar>
                    <ListItemText
                      secondary={
                        <div>
                          {/* <Typography className={classes.liquidPrimary}>
                            Produk
                          </Typography> */}
                          <Typography className={classes.liquidBold}>
                            {product.nama} - Ukuran{" "}
                            {product.variant?.variant1.nilai} Warna{" "}
                            {product.variant?.variant2.nilai} -{" "}
                            {suborder?.products_qty?.[index]} pcs
                          </Typography>
                          <Typography className={classes.liquidPrimary}>
                            Harga Barang
                          </Typography>
                          <Typography className={classes.liquidBold}>
                            {currency(
                              (suborder.products_subtotal?.[index] ?? 0) /
                                (suborder.products_qty?.[index] ?? 1)
                            )}
                          </Typography>
                        </div>
                      }
                    />
                  </ListItem>
                );
              })}
            </>
          ) : (
            <>
              {suborder.products?.length > 1 ? (
                <>
                  <ListItem button onClick={() => setSeeProduk(1)}>
                    <ListItemAvatar>
                      <Avatar
                        variant="square"
                        src={suborder.products?.[0]?.variant?.thumbnail?.[0]}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      secondary={
                        <div>
                          {/* <Typography className={classes.liquidPrimary}>
                            Produk
                          </Typography> */}
                          <Typography className={classes.liquidBold}>
                            {products}
                            More...
                          </Typography>
                          <Typography className={classes.liquidPrimary}>
                            Total Pembayaran
                          </Typography>
                          <Typography className={classes.liquidBold}>
                            {currency(suborder.total_pembayaran)}
                          </Typography>
                        </div>
                      }
                    />
                  </ListItem>
                </>
              ) : (
                <>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar
                        variant="square"
                        src={suborder.products?.[0]?.variant?.thumbnail?.[0]}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      secondary={
                        <div>
                          {/* <Typography className={classes.liquidPrimary}>
                            Produk
                          </Typography> */}
                          <Typography className={classes.liquidBold}>
                            {products}
                          </Typography>
                          <Typography className={classes.liquidPrimary}>
                            Total Pembayaran
                          </Typography>
                          <Typography className={classes.liquidBold}>
                            {currency(suborder.total_pembayaran)}
                          </Typography>
                        </div>
                      }
                    />
                  </ListItem>
                </>
              )}
            </>
          )}

          <Divider />
          <ListItem>
            <ListItemIcon style={{ minWidth: "40px" }}>
              <LoopIcon />
            </ListItemIcon>
            <ListItemText
              secondary={
                <Typography className={classes.liquidSecondList}>
                  Paket sedang diproses untuk segera dikirim
                </Typography>
              }
            />
            <ListItemSecondaryAction>
              {/* <IconButton
                edge="end"
                size="small"
                onClick={() => history.push("/")}
              > */}
              <Button
                onClick={() => history.push("/")}
                color="primary"
                variant="contained"
                size="small"
              >
                <Typography
                  style={{ color: "white", fontSize: "10px", padding: "2px" }}
                  className={classes.liquidSecondList}
                >
                  Beli Lagi
                </Typography>
              </Button>
              {/* <NavigateNextIcon />
              </IconButton> */}
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </Paper>
      <Gap height={30} />
    </>
  );
};

async function fetchSuborders(order) {
  const orderId = order.id;
  const suborders = [];
  try {
    const subordersRef = await ordersCollection
      .doc(orderId)
      .collection("suborders")
      .where("order_info.owner_id", "==", order.order_info.owner_id)
      .where("status_pengiriman", "in", ["on-process", "goods-issued"])
      .get();
    if (!subordersRef.empty) {
      subordersRef.docs.map((r) => {
        suborders.push({
          kode_order: order.kode_order,
          order_id: orderId,
          id: r.id,
          ...r.data(),
        });
      });
    }
  } catch (e) {
    console.log(e);
  }

  return suborders;
}

function DiProsess({ value, modes }) {
  const { orders } = useData();
  const [suborders, setSuborders] = useState([]);
  const [isReady, setIsReady] = useState(false);

  const pendingOrders =
    orders
      ?.filter((order) => {
        return (
          modes === order.order_info?.location &&
          (order.status === "on-process" || order.status === "on-delivery")
        );
      })
      .sort((a, b) => {
        const m2 = b.created_at?.toMillis?.() ?? 0;
        const m1 = a.created_at?.toMillis?.() ?? 0;

        return m2 - m1;
      }) ?? [];

  async function getSuborders() {
    const nextSuborders = [];

    for await (const order of pendingOrders) {
      const res = await fetchSuborders(order);
      nextSuborders.push(...res);
    }

    setSuborders(nextSuborders);
    setIsReady(true);
  }

  useEffect(() => {
    getSuborders();
  }, []);

  // if (!isReady) {
  //   return <Circle />;
  // }

  return (
    <TabPanel
      style={{ backgroundColor: "#EFF1FE" }}
      value={value}
      index="processed"
    >
      <div>
        {suborders && suborders.length > 0 ? (
          suborders.map((item) => {
            return <SubOrderItem key={item?.id} suborder={item} />;
          })
        ) : (
          <EmptyOrder />
        )}
      </div>
    </TabPanel>
  );
}

export default DiProsess;
